<template>
    <div class="d-flex flex-column align-items-center text-center">
        <b-form-group
                id="peopleCount-form"
                label="👷🏻‍♂️Введите количество рабочих на объекте и|или в дороге на объект"
                label-for="peopleCount"
                label-class="label-class"
                class="mt-md-5"
        >
          <div class="d-inline-flex align-items-center">
            <input type="number" id="peopleCount" v-model="peopleCount" step="1" placeholder="0"/>
            <span class="ml-2">чел.</span>
          </div>
        </b-form-group>
        <b-form-group
                id="pauseTime-form"
                label="🍗Продолжительность обеда в минутах"
                label-for="pauseTime"
                label-class="label-class"
        >
          <div class="d-inline-flex align-items-center">
            <input type="number" id="pauseTime" v-model="pauseTime" step="1" min="0" required placeholder="0"/>
            <span class="ml-2">мин.</span>
          </div>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: "StepThree",
    computed: {
        peopleCount: {
            get() {
                return this.$store.state.shiftReport.peopleCount;
            },
            set(v) {
                this.$store.commit(`shiftReport_setPeopleCount`, Number(v));
                this.$store.dispatch(`shiftReport_updateCache`);
            }
        },
        pauseTime: {
            get() {
                return this.$store.state.shiftReport.pauseTime;
            },
            set(v) {
                this.$store.commit(`shiftReport_setPauseTime`, v === `` || v === null || v === undefined ? null : Number(v));
                this.$store.dispatch(`shiftReport_updateCache`);
            }
        }
    },
    methods: {
        hasRequiredPauseTime(value) {
            return value !== `` && value !== null && value !== undefined && !Number.isNaN(Number(value)) && Number(value) >= 0;
        },
        canContinue(peopleCount, pauseTime) {
            return Boolean(peopleCount && peopleCount > 0 && this.hasRequiredPauseTime(pauseTime));
        },
        emitCanContinue(peopleCount = this.peopleCount, pauseTime = this.pauseTime) {
            this.$emit(`can-continue`, {
                value: this.canContinue(peopleCount, pauseTime)
            });
        }
    },
    mounted() {
        this.emitCanContinue();
    },
    watch: {
        peopleCount(v) {
            this.emitCanContinue(v, this.pauseTime);
        },
        pauseTime(v) {
            this.emitCanContinue(this.peopleCount, v);
        }
    }
}
</script>

<style scoped>

</style>
